"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getRoutes;

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _reactRouter = require("react-router");

var _routeAuthentication = require("../decorators/routeAuthentication");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function getRoutes(store) {
    var auth = store.getState().auth;
    var highestPermission = auth.highestPermission;
    /**
     * Please keep routes in alphabetical order
     */
    return React.createElement(_reactRouter.Route, { component: require("./containers/App") }, React.createElement(_reactRouter.Redirect, { from: _routeAuthentication.DEFAULT_AUTHENTICATED_PATH, to: "reports/open" }), React.createElement(_reactRouter.Route, { path: "reports", onEnter: (0, _routeAuthentication.ensureAuthenticatedOnEnter)(store), component: (0, _routeAuthentication.ensureAuthenticatedOnUpdate)(require("./containers/RouteWrapper")) }, React.createElement(_reactRouter.Route, { path: ":type", component: require("./containers/reports/ReportList") }), React.createElement(_reactRouter.Route, { path: "detail", component: require("./containers/RouteWrapper") }, React.createElement(_reactRouter.Route, { path: ":uid/:type/:definitionUid", component: require("./containers/reportDetail/ReportDetailContainer") }), React.createElement(_reactRouter.Route, { path: ":uid/:type/:definitionUid/:instanceUid", component: require("./containers/reportDetail/ReportDetailContainer") }))), React.createElement(_reactRouter.Route, { path: _routeAuthentication.DEFAULT_LOGIN_PATH, onEnter: (0, _routeAuthentication.toAuthenticatedOnEnter)(store), component: (0, _routeAuthentication.toAuthenticatedOnUpdate)(require("./containers/LoginPage")) }), React.createElement(_reactRouter.Route, { path: "*", status: 404, component: require("./containers/NotFoundPage") }));
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/routes.tsx
 ** module id = 1300
 ** module chunks = 0
 **/